import { render, staticRenderFns } from "./carousel_clients.vue?vue&type=template&id=54a48f42&scoped=true&"
import script from "./carousel_clients.vue?vue&type=script&lang=js&"
export * from "./carousel_clients.vue?vue&type=script&lang=js&"
import style0 from "./carousel_clients.vue?vue&type=style&index=0&id=54a48f42&lang=scss&scoped=true&"
import style1 from "./carousel_clients.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a48f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a48f42')) {
      api.createRecord('54a48f42', component.options)
    } else {
      api.reload('54a48f42', component.options)
    }
    module.hot.accept("./carousel_clients.vue?vue&type=template&id=54a48f42&scoped=true&", function () {
      api.rerender('54a48f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/carousel_clients.vue"
export default component.exports